import { render, staticRenderFns } from "./CamFront.vue?vue&type=template&id=befd8608&"
import script from "./CamFront.vue?vue&type=script&lang=js&"
export * from "./CamFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports